import React from 'react'
import { Autocomplete, Avatar, Box, TextField, Typography } from '@mui/material'
import { User, ApproverSettings } from 'types'

interface Props {
  users: User[]
  label: string
  type: keyof ApproverSettings
  selectedIds: string[]
  onAddApprover: (type: keyof ApproverSettings, value: string[]) => void
}

const RenderSingleApproverSetting: React.FC<Props> = ({ users, label, type, selectedIds, onAddApprover }) => {
  const getUserById = (id: string) => users.find(u => u.user_uuid === id)

  return (
    <Box>
      <Typography textAlign={'left'} fontWeight={600} gutterBottom>
        {label}
      </Typography>
      <Autocomplete
        multiple
        options={users}
        value={selectedIds.map(getUserById).filter(Boolean)}
        getOptionLabel={option => option?.name || ''}
        onChange={(_, newValue) => {
          const newIds = newValue.map(user => user.user_uuid)
          onAddApprover(type, newIds)
        }}
        renderTags={(tagValue, getTagProps) =>
          tagValue.map((option, index) => {
            const { key: _key, onDelete, ...rest } = getTagProps({ index })
            return (
              <Box
                key={option.user_uuid || index}
                {...rest}
                sx={{ display: 'flex', alignItems: 'center', height: '100%' }}
              >
                <Avatar
                  alt={option.name || option.firstName}
                  src={option.image_512}
                  sx={{ height: 36, width: 36, mr: 0.5 }}
                  onClick={onDelete} // 👈 Enable click-to-remove
                  style={{ cursor: 'pointer' }}
                />
              </Box>
            )
          })
        }
        renderInput={params => <TextField {...params} label={`Add ${label} Approvers`} variant="outlined" />}
      />
    </Box>
  )
}

export default RenderSingleApproverSetting
